(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["morrow-paid-leave-planner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const money = value => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(Math.max(0, value || 0));
    const publish = (eventName, detail = {}) => {
      try {
        const privacy = window.Shopify && window.Shopify.customerPrivacy;
        const allowed = privacy && privacy.value && privacy.value.allowedProcessing;
        if (allowed && allowed.analytics === false) return;
        const payload = { planner: 'paid_leave', ...detail };
        window.dispatchEvent(new CustomEvent(`morrow_mama:${eventName}`, { detail: payload }));
        const analytics = window.Shopify && window.Shopify.analytics;
        if (analytics && typeof analytics.publish === 'function') {
          const published = analytics.publish(`morrow_mama:${eventName}`, payload);
          if (published && typeof published.catch === 'function') published.catch(() => {});
        }
      } catch (error) {
      }
    };
    const cards = {
      CA: '<strong>California:</strong> Use the official DI/PFL calculator with base-period earnings. This planner does not estimate California benefits from salary alone. <a href="https://edd.ca.gov/PFL_calculator">Open the official calculator</a>. <em>Last reviewed September 14, 2026.</em>',
      NY: '<strong>New York:</strong> Check the current benefit-year schedule and employer coverage before using a number. <a href="https://paidfamilyleave.ny.gov">Open New York Paid Family Leave</a>. <em>Last reviewed September 14, 2026.</em>',
      NJ: '<strong>New Jersey:</strong> Confirm Family Leave Insurance eligibility, the current weekly maximum, and application steps. <a href="https://www.nj.gov/labor/myleavebenefits/worker/fli/index.shtml">Open New Jersey FLI</a>. <em>Last reviewed September 14, 2026.</em>',
      WA: '<strong>Washington:</strong> Use the official estimate and confirm how PTO is treated under your employer’s plan. <a href="https://paidleave.wa.gov/how-paid-leave-works/">Open Washington Paid Leave</a>. <em>Last reviewed September 14, 2026.</em>',
      MA: '<strong>Massachusetts:</strong> Use PFML’s official information and confirm any intermittent or part-time work effect. <a href="https://www.mass.gov/info-details/paid-family-and-medical-leave-pfml-overview-and-benefits">Open Massachusetts PFML</a>. <em>Last reviewed September 14, 2026.</em>',
      MD: '<strong>Maryland:</strong> General FAMLI employee benefits begin in January 2028. Do not count this as current pay for a 2026 leave plan. <a href="https://paidleave.maryland.gov/about-the-program/">Open Maryland FAMLI</a>. <em>Last reviewed September 14, 2026.</em>',
      OTHER: '<strong>Other state:</strong> Check your state labor agency, employer policy, and any private plan. Do not assume a statewide payment from this planner.'
    };
    document.querySelectorAll('[data-paid-leave-planner]').forEach(root => {
      const form = root.querySelector('[data-planner-form]');
      const results = root.querySelector('[data-results]');
      const success = root.querySelector('[data-paid-leave-lead-success]');
      const leadConfirmed = new URLSearchParams(window.location.search).get('lead') === 'paid-leave';
      if (leadConfirmed && success) {
        success.hidden = false;
        success.focus({ preventScroll: true });
        if (!sessionStorage.getItem('mm-paid-leave-lead-confirmed')) {
          publish('paid_leave_lead_submitted', { source: 'confirmed_return' });
          sessionStorage.setItem('mm-paid-leave-lead-confirmed', 'true');
        }
      }
      let plannerStarted = false;
      form.querySelectorAll('input, select').forEach(field => {
        field.addEventListener('focus', () => {
          if (plannerStarted) return;
          plannerStarted = true;
          publish('paid_leave_planner_started');
        }, { once: true });
      });
      root.querySelectorAll('[data-paid-leave-kit-cta]').forEach(link => {
        link.addEventListener('click', () => publish('paid_leave_kit_cta_clicked'));
      });
      form.addEventListener('submit', event => {
        event.preventDefault();
        const data = new FormData(form);
        const weeklyField = form.querySelector('[name="weeklyPay"]');
        const plannerError = form.querySelector('[data-planner-error]');
        const weeklyValidationMessage = form.dataset.validationWeekly;
        const number = name => Math.max(0, Number(data.get(name)) || 0);
        const weekly = number('weeklyPay'); const weeks = Math.min(26, number('leaveWeeks')); const employerWeeks = Math.min(weeks, number('employerWeeks')); const employerRate = Math.min(1, number('employerPercent') / 100);
        const ptoWeeks = Math.min(Math.max(0, weeks - employerWeeks), number('ptoDays') / 5); const stdWeeks = Math.min(weeks, number('stdWeeks')); const stdRate = Math.min(1, number('stdPercent') / 100); const cap = number('stdCap'); const waitWeeks = number('stdWaiting') / 7;
        if (!weekly || !weeks) {
          weeklyField.setAttribute('aria-invalid', 'true');
          plannerError.textContent = weeklyValidationMessage;
          plannerError.hidden = false;
          weeklyField.focus();
          return;
        }
        weeklyField.removeAttribute('aria-invalid');
        plannerError.hidden = true;
        let income = 0; const schedule = [];
        for (let week = 1; week <= weeks; week += 1) {
          const employer = week <= employerWeeks ? weekly * employerRate : 0;
          const pto = week > employerWeeks && week <= employerWeeks + ptoWeeks ? weekly : 0;
          const std = week > waitWeeks && week <= waitWeeks + stdWeeks ? Math.min(weekly * stdRate, cap || weekly * stdRate) : 0;
          const planned = Math.max(employer, pto, std);
          income += planned; schedule.push({ week, normal: weekly, planned, gap: Math.max(0, weekly - planned) });
        }
        const normal = weekly * weeks; const gap = Math.max(0, normal - income); const weeklyGap = gap / Math.max(1, weeks);
        root.querySelector('[data-total-income]').textContent = money(income); root.querySelector('[data-total-gap]').textContent = money(gap); root.querySelector('[data-weekly-gap]').textContent = money(weeklyGap);
        root.querySelector('[data-diagnosis]').textContent = gap > 0 ? `This is a gross income-replacement gap of ${money(gap)} versus your usual gross pay. It is not a take-home cash-flow estimate. Keep any state benefit, STD, or employer top-up out of the plan until the coordination rule is confirmed.` : 'The documented sources entered match your usual gross pay for this planned length. This is not a take-home cash-flow estimate; confirm coordination, deductions, and any waiting period before relying on it.';
        root.querySelector('[data-schedule]').innerHTML = schedule.map(item => `<tr><td>${item.week}</td><td>${money(item.normal)}</td><td>${money(item.planned)}</td><td>${money(item.gap)}</td></tr>`).join('');
        const state = data.get('state'); const card = root.querySelector('[data-state-card]'); card.hidden = !state; card.innerHTML = state ? cards[state] : '';
        publish('paid_leave_planner_completed', { state_selected: Boolean(state) });
        results.hidden = false; results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
